import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '@/assets/images/logo.png';
const _hoisted_1 = {
  class: "indexPage-searchBox"
};
const _hoisted_2 = {
  class: "indexPage-searchBox-container"
};
const _hoisted_3 = {
  class: "indexPage-searchBox-right"
};
const _hoisted_4 = {
  class: "tabs"
};
const _hoisted_5 = ["href", "target"];
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import Cookies from "js-cookie";
import { getBannerConfig } from "@/network/api/homePage";
export default {
  __name: 'AppHeader',
  setup(__props) {
    const router = useRouter();

    // 主导航数据
    const mainNavList = ref([]);

    // 获取主导航数据
    const getMainNavData = () => {
      getBannerConfig({
        op: JSON.stringify({
          name: "="
        }),
        filter: JSON.stringify({
          name: "main_nav"
        }),
        page: "1",
        limit: "20",
        sort: "id",
        order: "desc"
      }).then(res => {
        if (res.code == 1 && res.data.rows.length > 0) {
          // 查找name为"main_nav"的配置项
          const mainNavConfig = res.data.rows.find(item => item.name === "main_nav");
          if (mainNavConfig && mainNavConfig.value && mainNavConfig.value.trim() !== '') {
            try {
              // 解析value字段的对象格式数据
              const valueObj = JSON.parse(mainNavConfig.value);
              // 转换为数组格式
              const navData = Object.entries(valueObj).map(([name, link]) => ({
                name: name,
                link: link
              }));

              // 转换为导航数据格式
              mainNavList.value = navData.map((item, index) => ({
                id: index,
                name: item.name || '',
                link: item.link || '',
                target: item.link && (item.link.startsWith('http://') || item.link.startsWith('https://')) ? '_blank' : '_self'
              }));
            } catch (error) {
              // 如果JSON解析失败，使用默认导航数据
              console.warn('主导航value字段解析失败，使用默认导航');
              setDefaultNav();
            }
          } else {
            // 如果没有找到配置或value为空，使用默认导航数据
            setDefaultNav();
          }
        } else {
          // 接口返回失败，使用默认导航数据
          setDefaultNav();
        }
      }).catch(error => {
        // 接口请求失败，使用默认导航数据
        console.error('获取主导航数据失败:', error);
        setDefaultNav();
      });
    };

    // 设置默认导航数据
    const setDefaultNav = () => {
      mainNavList.value = [{
        id: 1,
        name: '选课中心',
        link: '/course',
        target: '_self'
      }, {
        id: 2,
        name: '考试报名',
        link: '/exam',
        target: '_self'
      }, {
        id: 3,
        name: '成绩查询',
        link: '/score',
        target: '_self'
      }, {
        id: 4,
        name: '在线考试',
        link: '/online-exam',
        target: '_self'
      }, {
        id: 5,
        name: '资料下载',
        link: '/download',
        target: '_self'
      }, {
        id: 6,
        name: '网上书店',
        link: '/bookstore',
        target: '_self'
      }, {
        id: 7,
        name: '免费试听',
        link: '/audition',
        target: '_self'
      }];
    };
    const gotoHomePage = () => {
      router.push("/");
    };

    // 用户登录
    const userLogin = () => {
      router.push("/loginPage");
    };

    // 组件挂载时获取主导航数据
    onMounted(() => {
      getMainNavData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "indexPage-header"
      }, [_createElementVNode("div", {
        class: "indexPage-header-container"
      }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "indexPage-header-left"
      }, [_createElementVNode("div", {
        class: "timeDate"
      }, " 2024年8月21日 星期三 "), _createElementVNode("div", {
        class: "apply"
      }, " 2012国家公务员考试成绩查询 ")], -1)), _createElementVNode("div", {
        class: "indexPage-header-right"
      }, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "about"
      }, [_createElementVNode("span", null, "关于我们"), _createElementVNode("span", null, "帮助中心"), _createElementVNode("span", null, "师资团队")], -1)), _createElementVNode("div", {
        class: "login"
      }, [_createElementVNode("span", {
        onClick: userLogin
      }, "登录"), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "splice"
      }, null, -1)), _cache[1] || (_cache[1] = _createElementVNode("span", null, "注册", -1))])])])]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "indexPage-searchBox-left",
        onClick: gotoHomePage
      }, _cache[4] || (_cache[4] = [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "logo"
      }, null, -1), _createElementVNode("div", {
        class: "title"
      }, " 国内教育考试门户网站 ", -1)])), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainNavList.value, nav => {
        return _openBlock(), _createElementBlock("a", {
          key: nav.id,
          href: nav.link,
          target: nav.target,
          class: "nav-link"
        }, _toDisplayString(nav.name), 9, _hoisted_5);
      }), 128))])])])])], 64);
    };
  }
};